import { OnboardingStepType } from '@account_module/types/Onboarding';

export type OnboardingType = 'megaphone';

export const ONBOARDING_TYPE = {
  MEGAPHONE: 'megaphone' as OnboardingType,
};

export const MEGAPHONE_ONBOARDING_STEPS = {
  VERIFY_CREDENTIALS: 'verify_credentials' as OnboardingStepType,
  CUSTOMIZE_IMPORT: 'customize_import' as OnboardingStepType,
  HANDLE_DUPLICATE: 'handle_dupicate' as OnboardingStepType,
  SUCCESS: 'success' as OnboardingStepType,
};
